var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TipTap',{attrs:{"menu_items":[],"readonly":true,"is_walkthrough":_vm.is_walkthrough},model:{value:(_vm.question.content.question),callback:function ($$v) {_vm.$set(_vm.question.content, "question", $$v)},expression:"question.content.question"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }